import btnStyle from '@/components/Shares/Button.module.css';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Button, Image, Paper, Stack, Text, rem } from '@mantine/core';
export const ProfileUnboxChest: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Paper radius={5} p="48px 16px 32px" bd="2px dashed var(--icon-primary)" bg="rgba(26, 31, 38, 0.95)" pos="relative">
      <Image src="/assets/kyc/chest.svg" alt="chest" w={60} h={60} pos="absolute" inset="-32px 0px auto" mx="auto" />
      <Stack>
        <Text ta="center" fz={20} lh={rem(22)} className={gunterzBold.className}>
          {i18n._('unlock exclusive items and gear with lootboxes!')}
        </Text>
        <Button mx="auto" p={0} w={140} h={40} fz="xs" classNames={{
        root: btnStyle.root
      }}>
          {i18n._('visit lootboxes')}
        </Button>
      </Stack>
    </Paper>;
};